import { render, staticRenderFns } from "./IconDoubling.vue?vue&type=template&id=101ab5b6&scoped=true&"
import script from "./IconDoubling.vue?vue&type=script&lang=js&"
export * from "./IconDoubling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101ab5b6",
  null
  
)

export default component.exports